import React from 'react';
import { Icon } from './Icon';
import { useTheme } from '@/hooks/useTheme';

interface SearchBarProps {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
}

export function SearchBar({ value, onChangeText, placeholder = 'Rechercher...' }: SearchBarProps) {
  const colors = useTheme();

  return (
    <div style={{ ...styles.container, backgroundColor: colors.surface }}>
      <Icon name="search" size={20} color={colors.textSecondary} />
      <input
        type="text"
        style={{ ...styles.input, color: colors.text }}
        value={value}
        onChange={(e) => onChangeText(e.target.value)}
        placeholder={placeholder}
        autoCapitalize="none"
        autoCorrect="off"
      />
      {value.length > 0 && (
        <button onClick={() => onChangeText('')} style={styles.clearButton}>
          <Icon name="close-circle" size={20} color={colors.textSecondary} />
        </button>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 24,
    paddingLeft: 16,
    paddingRight: 16,
    height: 48,
    gap: 8,
  },
  input: {
    flex: 1,
    fontSize: 16,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    width: '100%',
  },
  clearButton: {
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
